import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './Hero.css';
import BookingForm from './BookingForm';

const Hero = () => {
  const [showBookingForm, setShowBookingForm] = useState(false);

   const handleBookNow = () => {
    setShowBookingForm(true);
  };

  const handleCloseBooking = () => {
    setShowBookingForm(false);
    // Fix button color after form closes
    const buttons = document.querySelectorAll('.book-appointment-btn');
    buttons.forEach(button => {
      button.style.backgroundColor = 'var(--accent-color)';
      button.style.border = 'none';
      button.style.color = 'var(--white-color)';
    });
  };
  return (
    <div className="hero-section" id="home">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} md={12} className="hero-text">
            <div className="hero-content">
              <h1>
                <span className="hero-title">Quality Medical Care</span>
                <br />
                <span className="hero-subtitle">At Your Home</span>
              </h1>
              <p>
                Caremetto Healthcare is Bangalore's trusted provider of home healthcare services. We deliver high-quality, personalized care to patients recovering from illness or injury across Bangalore, ensuring comfort and support at home. With compassion and professionalism, our team of Bangalore-based healthcare professionals goes beyond standard care to prioritize your well-being and recovery.
              </p>
              <div className="hero-buttons">
                <Button onClick={handleBookNow} className="book-appointment-btn">Book Appointment</Button>
                {/* <Button variant="outline-primary" className="call-now-btn">Call Now</Button> */}
              </div>
              <div className="hero-features">
                <div className="feature">
                  <div className="feature-icon">
                    <i className="certified-icon">✓</i>
                  </div>
                  <div className="feature-text">
                    <span>Certified</span>
                    <span>Professionals</span>
                  </div>
                </div>
                <div className="feature">
                  <div className="feature-icon">
                    <i className="time-icon">⏰</i>
                  </div>
                  <div className="feature-text">
                    <span>24/7</span>
                    <span>Available</span>
                  </div>
                </div>
                <div className="feature">
                  <div className="feature-icon">
                    <i className="home-icon">🏠</i>
                  </div>
                  <div className="feature-text">
                    <span>Home</span>
                    <span>Service</span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} md={12} className="hero-image">
            <div className="stats-badge">
              <div className="stats-icon">👥</div>
              <div className="stats-text">
                <div className="stats-number">1,00,000+</div>
                <div className="stats-label">Patients Served</div>
              </div>
            </div>
            <div className="image-container">
              <img src="/images/doctor.jpg" alt="Healthcare Professional" className="doctor-image" />
            </div>
          </Col>
        </Row>
         <BookingForm 
        show={showBookingForm} 
        handleClose={handleCloseBooking} 
        defaultService="Care Giver"
         />
      </Container>
    </div>
  );
};

export default Hero;